import axios,{AxiosRequestConfig} from 'axios';
export class ServiceRequest {
    public Post(baseURl: string,endpoint: string,data?: any,fnsuccess?: any, fnerror?:any, fnloading?:any,extheaders?:any) {
        let url=baseURl+endpoint;
        fnloading(1,endpoint);
        let extconfig={};
        if(extheaders){
          extconfig={
            headers:extheaders
          };
        }
        axios.post(url,data,extconfig).then((res) => { 
                                              fnloading(-1,endpoint); 
                                              fnsuccess(res); },
                                            (err) => {
                                                fnloading(-1,endpoint); 
                                                fnerror(err); }).catch((error) => {
                                                  console.error(error);
        }); 
        /*let Config ={
            url: baseURl+endpoint,
            method: 'POST',        
            data: data        
          };
        return axios(Config);
        
        let Config = {
      url: apiurl,
      method: 'GET',
      headers: header
    };
    fnloading(1);
    axios(Config).then(
      (res) => { fnloading(-1); fnsuccess(res); },
      (err) => { fnloading(-1); fnerror(err); }).catch((error) => {

      });
        */
    }
    public Get(baseURl: string,endpoint: string,data:any,fnsuccess:Function, fnerror:Function, fnloading:Function) {
        let url=baseURl+endpoint;
        fnloading(1,endpoint);
        axios.get(url).then((res) => { fnloading(-1,endpoint); fnsuccess(res); },
                            (err) => { fnloading(-1,endpoint); fnerror(err); }).catch((error) => {
                              console.error(error);
        }); 
        /*let Config ={
            url: baseURl+endpoint,
            method: 'GET',        
            data: data        
          };
        return axios(Config);*/
    }
    public PostJSON(baseURl: string,endpoint: string,data?: any,fnsuccess?: any, fnerror?:any, fnloading?:any,extheaders?:any){
      let url=baseURl+endpoint;
      fnloading(1,endpoint);
      let Config:AxiosRequestConfig = {
        url: url,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      axios(Config).then((res) => { 
                            fnloading(-1,endpoint); 
                            fnsuccess(res); },
                         (err) => {
                            fnloading(-1,endpoint); 
                            fnerror(err); }).catch((error) => {
                              console.error(error);
                          }); 
    }
  }
